import React, { Component } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import AvatarGroup from './components/AvatarGroup/AvatarGroup';
//import TextGroup from './components/TextGroup/TextGroup'
import TextSolo from './components/TextGroup/TextSolo'
import Controls from './components/Controls/Controls';
import classes from './App.css';
import backgrounds from './img/backgrounds/Backgrounds';
import framesTop from './img/frame-top/FramesTop';
import framesBottom from './img/frame-bottom/FramesBottom';
import giftsList from './img/gifts/gifts';
import fonts from './UI/Fonts/Fonts';
//import styles from './UI/Styles/Styles';
import palette from './UI/Palette/Palette';
import ControlsToggle from './components/ControlsToggle/ControlsToggle';
import Gift from "./components/Gifts/Gift";
//import EXIF from 'exif-js';
//import car from './img/car_default.png'
//import car from './img/car_element.png'
import car from './img/car_text.png'

//let textIndex = 0;

let carXposVar = () => {
  if (window.innerWidth >= 1120) {
    return window.innerWidth - 500
  } else if (window.innerWidth > 768 && window.innerWidth < 1120) {
    return window.innerWidth - 400
  } else if (window.innerWidth > 640 && window.innerWidth < 768) {
    return window.innerWidth - 120;
  } else {
    return window.innerWidth - 120;
  }
}

let carYposVar = () => {
  if (window.innerHeight >= 860) {
    return window.innerHeight - 320
  } else if (window.innerHeight > 740 && window.innerHeight < 860) {
    return window.innerHeight - 180
  } else if (window.innerHeight < 740) {
    return window.innerHeight - 160
  } else {
    return window.innerHeight - 120
  }
}

let carWidthVar = () => {
  if (window.innerWidth >= 1120) {
    return 250
  } else if (window.innerWidth > 768 && window.innerWidth < 1120) {
    return 140
  } else if (window.innerWidth > 640 && window.innerWidth < 768) {
    return 120;
  } else {
    return 120;
  }
}

let carHeightVar = () => {
  if (window.innerHeight >= 860) {
    return 328
  } else if (window.innerHeight > 740 && window.innerHeight < 860) {
    return 180
  } else if (window.innerHeight < 740) {
    return 160
  } else {
    return 160
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth > 1120 ? 1120 - 260 : window.innerWidth > 768 ? window.innerWidth - 260 : window.innerWidth,
      height: window.innerHeight,
      textWidth: 300,
      textHeight: 50,
      background: null,
      frameTop: null,
      frameBottom: null,
      textStyle: null,
      textColor: '#333',
      imgSide: 200,
      fontFamily: fonts[0],
      imgSideWidth: 150,
      imgSideHeight: 150,
      avatarPosition: null,
      zoomerSide: 40,
      showPalette: false,
      showGiftPalette:false,
      showControls: window.innerWidth > 768,
      gifts:[],
      texts:[],
      currentTextSet:{
        color: '#ff0000',
        family: fonts[0],
        italic: false,
        bold: false,
        underline: false,
        size: 22,
        value: 'Текст',
        unit: null,
      },
      carOpacity: 1,
      //carX: window.innerWidth > 1120 ? 1120 - 500 : window.innerWidth > 480 ? window.innerWidth - 200 : window.innerWidth - 150,
      //carY: window.innerWidth > 1120 ? window.innerHeight - 328 : window.innerWidth > 480 ? window.innerHeight - 262 : window.innerHeight - 197,
      carX: carXposVar(),
      carY: carYposVar(),
      //carWidth: window.innerWidth > 1120 ? 250 : window.innerWidth > 480 ? 200 : 150,
      //carHeight: window.innerWidth > 1120 ? 328 : window.innerWidth > 480 ? 262 : 197,
      carWidth: carWidthVar(),
      carHeight: carHeightVar(),
    }
  }
  currentBackground = 0;
  currentFrameTop = 0;
  currentFrameBottom = 0;


  componentDidMount() {
    const image = new window.Image();
    image.src = backgrounds[0];
    image.onload = () => {
      this.setState({
        background: image
      });
    }

    const imageFrameTop = new window.Image();
    imageFrameTop.src = framesTop[0];
    imageFrameTop.onload = () => {
      this.setState({
        frameTop: imageFrameTop
      });
    }

    const imageFrameBottom = new window.Image();
    imageFrameBottom.src = framesBottom[0];
    imageFrameBottom.onload = () => {
      this.setState({
        frameBottom: imageFrameBottom
      });
    }


    for (let i = 0; i < 2; i++) {
      this.addText(true, 0, this.state.width/2-60, (i+1) * 0.25 * this.state.height, 300, 50, '#333', fonts[0], false, false, false, 22+(i*5), `Текст ${this.textCounter()}`);
    }
  }

  toggleControls = () => {
    this.setState(prevState => {
      return {showControls: !prevState.showControls}
    })
  }

  openControls = () => {
    this.setState({
      showControls: true
    })
  }

  onInputChange = (e, prop) => {
    this.setState({[prop]: e.target.value})
  }

  onInputCheck = (e, prop) => {
    this.setState(prevState => ({[prop]: !prevState[prop]}))
  }

  setInitialPosition = (x, y, prop) => {
    this.setState({[prop]: {x, y}})
  }

  /*FRAMETOP*/
  chooseNextFrameTop = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = framesTop[this.currentFrameTop + 1] ? framesTop[this.currentFrameTop + 1] : framesTop[0];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameTop").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameTop").getLayer().batchDraw();
      this.currentFrameTop = (this.currentFrameTop + 1) < framesTop.length ? this.currentFrameTop + 1 : 0;
    };
  }

  choosePrevFrameTop = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = framesTop[this.currentFrameTop - 1] ? framesTop[this.currentFrameTop - 1] : framesTop[framesTop.length - 1];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameTop").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameTop").getLayer().batchDraw();
      this.currentFrameTop = (this.currentFrameTop - 1) > -1 ? this.currentFrameTop - 1 : framesTop.length - 1;
    };
  }

  chooseRandFrameTop = () => {
    const bckgrndImg = new window.Image();
    const randBcgr = Math.floor(Math.random() * framesTop.length);
    bckgrndImg.src = framesTop[randBcgr];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameTop").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameTop").getLayer().batchDraw();
      this.currentFrameTop = randBcgr;
    };
  }

  /*FRAMEBOTTOM*/
  chooseNextFrameBottom = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = framesBottom[this.currentFrameBottom + 1] ? framesBottom[this.currentFrameBottom + 1] : framesBottom[0];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameBottom").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameBottom").getLayer().batchDraw();
      this.currentFrameBottom = (this.currentFrameBottom + 1) < framesBottom.length ? this.currentFrameBottom + 1 : 0;
    };
  }

  choosePrevFrameBottom = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = framesBottom[this.currentFrameBottom - 1] ? framesBottom[this.currentFrameBottom - 1] : framesBottom[framesBottom.length - 1];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameBottom").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameBottom").getLayer().batchDraw();
      this.currentFrameBottom = (this.currentFrameBottom - 1) > -1 ? this.currentFrameBottom - 1 : framesBottom.length - 1;
    };
  }

  chooseRandFrameBottom = () => {
    const bckgrndImg = new window.Image();
    const randBcgr = Math.floor(Math.random() * framesBottom.length);
    bckgrndImg.src = framesBottom[randBcgr];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".frameBottom").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".frameBottom").getLayer().batchDraw();
      this.currentFrameBottom = randBcgr;
    };
  }


  /*BACKGROUND*/
  chooseNextBackground = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = backgrounds[this.currentBackground + 1] ? backgrounds[this.currentBackground + 1] : backgrounds[0];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".background").getLayer().batchDraw();
      this.currentBackground = (this.currentBackground + 1) < backgrounds.length ? this.currentBackground + 1 : 0;
    };
  }

  choosePrevBackground = () => {
    const bckgrndImg = new window.Image();
    bckgrndImg.src = backgrounds[this.currentBackground - 1] ? backgrounds[this.currentBackground - 1] : backgrounds[backgrounds.length - 1];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".background").getLayer().batchDraw();
      this.currentBackground = (this.currentBackground - 1) > -1 ? this.currentBackground - 1 : backgrounds.length - 1;
    };
  }

  chooseRandBackground = () => {
    const bckgrndImg = new window.Image();
    const randBcgr = Math.floor(Math.random() * backgrounds.length);
    bckgrndImg.src = backgrounds[randBcgr];
    bckgrndImg.onload = () => {
      this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
      this.stage.getStage().findOne(".background").getLayer().batchDraw();
      this.currentBackground = randBcgr;
    };
  }

  onFileInputChange = (e) => {
    const newAvatar = new window.Image();
    //newAvatar.setAttribute('crossOrigin', 'anonymous');
    newAvatar.onload = () => {
      let width = newAvatar.width;
      let height = newAvatar.height;
      if (width > height) {
        const k = width/height;
        if (width >= window.innerWidth/2) {
          width = window.innerWidth/2;
          height = width/k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      } else {
        const k = height/width;
        if (height >= window.innerHeight/2) {
          height = window.innerHeight/2;
          width = height/k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      }

      this.stage.getStage().findOne(".avatar").getImage().src = newAvatar.src;
      this.stage.getStage().findOne(".avatar").getImage().width = newAvatar.width;
      this.stage.getStage().findOne(".avatar").getImage().height = newAvatar.height;
      this.stage.getStage().findOne(".avatar").getLayer().batchDraw();
    };
    newAvatar.src = window.URL.createObjectURL(e.target.files[0]);
  }

  avatarUnderFrames = () => {
    this.stage.getStage().findOne(".frameBottom").setZIndex(4);
    this.stage.getStage().findOne(".frameTop").setZIndex(4);
    this.stage.getStage().findOne(".avatar").setZIndex(3);
  }

  avatarAboveFrames = () => {
    this.stage.getStage().findOne(".frameBottom").setZIndex(2);
    this.stage.getStage().findOne(".frameTop").setZIndex(2);
    this.stage.getStage().findOne(".avatar").setZIndex(3);
  }

  disableTransform = () => {
    let transformArray = [];
    transformArray.push(this.stage.getStage().findOne(".avatar-transform"));
    /*    transformArray.push(this.stage.getStage().findOne(".text1-transform"));
     transformArray.push(this.stage.getStage().findOne(".text2-transform"));
     transformArray.push(this.stage.getStage().findOne(".text3-transform"));*/
    transformArray.push(this.stage.getStage().find(".newTexts-tranformer"));
    this.stage.getStage().find("Transformer").forEach((transformer) => {
      if (~transformer.name().indexOf('gift-transform')) {
        transformArray.push(transformer);
      }
    })
    transformArray.push(this.stage.getStage().find(".gift-transform"));
    transformArray.forEach(item => item.resizeEnabled(false).rotateEnabled(false).borderEnabled(false).forceUpdate());
    transformArray[0].getLayer().batchDraw();
    this.stage.getStage().find(node => {
      return node.getName() === 'text1-zoomer' || node.getName() === 'text2-zoomer' || node.getName() === 'text3-zoomer'
    }).forEach(zoomer => zoomer.hide());

    this.avatarUnderFrames();
  }
  enableTransform = (elem) => {
    if (~elem.name().indexOf('text')){
      elem.parent.findOne('Transformer').borderEnabled(true).rotateEnabled(true);
      elem.parent.findOne('Transformer').getLayer().batchDraw();
      elem.parent.findOne('Transformer').forceUpdate();
      let array = elem.parent.findOne('Transformer').find('Shape');
      array.forEach((sh) => {
        sh.attrs.stroke = "#fff";
        sh.attrs.strokeWidth = '2';
        sh.attrs.dash = [5,2];
      })
    } else if (~elem.name().indexOf('gift')){
      elem.parent.findOne('Transformer').rotateEnabled(true).borderEnabled(true).resizeEnabled(true);
      elem.parent.findOne('Transformer').getLayer().batchDraw();
      elem.parent.findOne('Transformer').forceUpdate();
    }

    this.avatarAboveFrames();
  }
  /*
   reduceFont = (text) => {
   this.setState(prevState => {
   return {[text]: prevState[text]-2 > 8 ? prevState[text]-2 : prevState[text]}
   });
   }

   expandFont = (text) => {
   this.setState(prevState => {
   return {[text]: prevState[text]+2 < 80 ? prevState[text]+2 : prevState[text]}
   });
   }

   chooseNextStyle = () => {
   styles[this.currentStyle + 1] ? this.currentStyle+=1 : this.currentStyle = 0;
   this.setState({textStyle: styles[this.currentStyle]})
   }

   choosePrevStyle = () => {
   styles[this.currentStyle - 1] ? this.currentStyle-=1 : this.currentStyle = styles.length - 1;
   this.setState({textStyle: styles[this.currentStyle]})
   }

   chooseNextFont = () => {
   fonts[this.currentFont + 1] ? this.currentFont+=1 : this.currentFont = 0;
   this.setState({fontFamily: fonts[this.currentFont]})
   }

   choosePrevFont = () => {
   fonts[this.currentFont - 1] ? this.currentFont-=1 : this.currentFont = fonts.length - 1;
   this.setState({fontFamily: fonts[this.currentFont]})
   }
   */
  toggleShowPalette = () => {
    this.setState(prevState => ({
        showPalette: !prevState.showPalette
      })
    )
  }
  toggleShowGiftPalette = () => {
    this.setState(prevState => ({
      showGiftPalette: !prevState.showGiftPalette
      })
    )
  }
  showCloseGiftPalette = (show) => {
    this.setState({
      showGiftPalette: show
    })
  }
  chooseTextColor = (e) => {
    this.setState({textColor: e.target.id})
  }

  onStageClick = (e) => {
    if (e.target.name() === 'background') {
      this.disableTransform();
      this.setPropsToAside(null);
    } else if (~e.target.name().indexOf('text')) {
      this.disableTransform();
      this.enableTransform(e.target);
      this.setPropsToAside(e.target);
      this.openControls();
    } else if (~e.target.name().indexOf('gift')) {
      this.disableTransform();
      this.setPropsToAside(null);
      this.enableTransform(e.target);
    }
    this.showCloseGiftPalette(false);
  }

  saveStage = () => {
    this.disableTransform();
    this.hideCar();
    let downloadURI = (uri, name) => {
      if (window.navigator.msSaveBlob) {
        let dataURItoBlob = (uri) => {
          var binary = atob(uri.split(',')[1]);
          var array = [];
          for(var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], {type: 'image/png'});
        }
        var blob = dataURItoBlob(uri);
        window.navigator.msSaveOrOpenBlob(blob, "23feb.png");
      } else {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    // setTimeout, чтобы конва успела удалить рамки, если пользователь этого не сделал, и перерисоваться
    setTimeout(()=> {
      let dataURL = this.stage.getStage().toDataURL();
      downloadURI(dataURL, '23feb.png');
      this.showCar();
    },400);
    setTimeout(()=> {
          this.avatarAboveFrames();
        }
    ,400);
  }

  randomize = () => {
    this.chooseRandBackground();
    let texts = this.state.texts;
    texts.forEach(text => {
      text.color = `#${Math.floor(Math.random()*16777215).toString(16)}`;
      text.family = fonts[Math.floor(Math.random()*fonts.length)];
      text.italic = Math.round(Math.random());
      text.bold = Math.round(Math.random());
      text.underline = Math.round(Math.random());
      text.size = Math.floor(Math.random() * 22 + 20);
    });
    this.setState({
      texts: Object.assign(this.state.texts, texts)
    });
    setTimeout(() => {this.chooseRandFrameTop();}, 0);
    setTimeout(() => {this.chooseRandFrameBottom();}, 0);
  }

  addShape = (e, sType) => {
    let newCustomShapes = this.state.customShapes;
    newCustomShapes.push({type: sType});
    this.setState({
      customShapes: newCustomShapes
    })
  }

  addGift = (e,
             name,
             x = this.state.width/2 - 225 + Math.floor(Math.random()*200),
             y = this.state.height/1.6 - 225 + Math.floor(Math.random()*200),
             side = 125) => {
    let gifts = this.state.gifts;
    let image = new window.Image();
    giftsList.forEach(g => {
      if (g.name === name) {
        image.src = g.url;
      }
    });
    gifts.push({name: name, x: x, y: y, side: side, image: image});
    this.showCloseGiftPalette(false);
    this.setState({
      gifts: gifts
    })
  }

  makeCounter = () => {
    let count = 1;
    return () => {
      return count++;
    }
  }

  textCounter = this.makeCounter();

  setGiftInitialPosition = (x, y, giftNum, group) => {
    if (x + group.props.side/2 >= this.state.carX && y + group.props.side/2 >= this.state.carY) {
      if (group.transform.parent.findOne('Image')) {
        group.transform.parent.findOne('Image').destroy();
      }
      group.transform.rotateEnabled(false);
      group.transform.borderEnabled(false);
      group.transform.resizeEnabled(false);
    }
    const currentGifts = this.state.gifts;
    currentGifts[giftNum].x = x;
    currentGifts[giftNum].y = y;
    this.setState({
      gifts: currentGifts
    })
  }

  setTextInitialPosition = (x, y, textNum, group) => {
    if (x + group.transform.parent.findOne('Text').textWidth/2 >= this.state.carX && y + group.transform.parent.findOne('Text').textHeight/2 >= this.state.carY) {
      group.transform.parent.findOne('Text').remove();
      group.transform.rotateEnabled(false);
      group.transform.borderEnabled(false);
      this.setState({
        currentTextSet: {
          color: '',
          family: '',
          italic: false,
          bold: false,
          underline: false,
          size: '',
          value: '',
          unit: null,
        }
      })
    } else {
      const currentTexts = this.state.texts;
      currentTexts[textNum].x = x;
      currentTexts[textNum].y = y;
      this.setState({
        texts: currentTexts,
      })
    }
  }

  addText = (e,
             i = 0,
             x = Math.floor(Math.random()*(this.state.width*0.7) + this.state.width*0.15),
             y = Math.floor(Math.random()*(this.state.height*0.7) + this.state.height*0.15),
             width = 300,
             height = 50,
             color = '#ff0000',
             family = fonts[0],
             italic = false,
             bold = false,
             underline = false,
             size = 28,
             value = `Текст ${this.textCounter()}`) => {
    const currentTexts = this.state.texts;
    currentTexts.push({
      x: x,
      y: y,
      width: width,
      height: height,
      color: color,
      family: family,
      italic: italic,
      bold: bold,
      underline: underline,
      size: size,
      value: value,
    })
    this.setState({
      texts: currentTexts
    })
  }


  setPropsToAside = (text) => {
    if (text !== null) {
      let isBold, isItalic, isUnderline;
      if (~text.attrs.fontStyle.indexOf('bold')) {
        isBold = true;
      } else {
        isBold = false;
      }
      if (~text.attrs.fontStyle.indexOf('italic')) {
        isItalic = true;
      } else {
        isItalic = false;
      }
      if (~text.attrs.textDecoration.indexOf('underline')) {
        isUnderline = true;
      } else {
        isUnderline = false;
      }
      this.setState({
        currentTextSet: {
          color: text.attrs.fill,
          family: text.attrs.fontFamily,
          italic: isItalic,
          bold: isBold,
          underline: isUnderline,
          size: text.attrs.fontSize,
          value: text.attrs.text,
          unit: text.attrs.id >= 0 ? text.attrs.id : 0,
        }
      })
    } else {
      this.setState({
        currentTextSet: {
          color: '',
          family: '',
          italic: false,
          bold: false,
          underline: false,
          size: '',
          value: '',
          unit: null,
        }
      })
    }
  }

  sendToServer = () => {
    /*        this.disableTransform();

     const makeRequest = async () => {
     try {
     var XHR = window.XDomainRequest || window.XMLHttpRequest;
     var xhr = new XHR();
     xhr.open('POST', 'https://www.domkino.tv/vkcover/musketeer/photo', true);
     xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
     let dataURL = await this.stage.getStage().toDataURL();
     xhr.send('photo=' + encodeURIComponent(dataURL));
     xhr.onload = function() {
     alert( "Отерытка успешно отправлена" );
     }
     xhr.onerror = function() {
     alert( "Возникла ошибка. Попробуйте позже" );
     }
     } catch (err) {
     console.log(err)
     }
     }
     setTimeout(()=> {
     makeRequest();
     },400);*/
  }

  changeFontColor = (color, prop) => {
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet,{[prop]: color})
    })
  }

  changeFontSize = (expand, size) => {
    let newTextSet = Object.assign({},this.state.currentTextSet)
    expand ? newTextSet[size]++ : newTextSet[size]--
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet,{[size]: newTextSet[size]})
    })
  }

  changeFontFamily = (next, prop) => {
    let index;
    fonts.forEach((font, i) => {
      if (this.state.currentTextSet.family === font) {
        index = i;
      }
    })
    if (!next) {
      fonts[index - 1] ? index-=1 : index = fonts.length - 1;
    } else {
      fonts[index + 1] ? index+=1 : index = 0;
    }
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet, {[prop]: fonts[index]})
    })
  }

  findTextAndSetProps = (e, prop) => {
    switch (prop) {
      case "value":
        this.onChangeCurrentText(e.target.value, prop);
        break;
      case "size":
        this.changeFontSize(e, prop);
        break;
      case "color":
        this.changeFontColor(e.target.id, prop);
        break;
      case "family":
        this.changeFontFamily(e, prop);
        break;
      case "italic":
        this.toggleStyle(prop);
        break;
      case "bold":
        this.toggleStyle(prop);
        break;
      case "underline":
        this.toggleStyle(prop);
        break;
      default:
        break;
    }
    let allTexts = this.state.texts;
    for (let i = 0; i < allTexts.length; i++) {
      if (i === this.state.currentTextSet.unit) {
        allTexts[i] = Object.assign(allTexts[i], this.state.currentTextSet)
      }
    }
    this.setState({
      texts: allTexts
    })
    if (this.stage.getStage().findOne(`#${this.state.currentTextSet.unit}`)){
      this.enableTransform(this.stage.getStage().findOne(`#${this.state.currentTextSet.unit}`))
    }
  }

  onChangeCurrentText = (val, prop) => {
    let newCurrentTextSet = Object.assign({},this.state.currentTextSet);
    newCurrentTextSet[prop] = val;
    if (prop === "value"){
      this.setState({
        currentTextSet: Object.assign(this.state.currentTextSet,{[prop]: val})
      })
    }
  }

  toggleStyle = (prop) => {
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet, {[prop]: !this.state.currentTextSet[prop]})
    })
  }

  deleteElement = () => {

  }

  hideCar = () => {
      this.setState({
        carOpacity: 0
      })
  }

  showCar = () => {
    this.setState({
      carOpacity: 1
    })
  }

  render() {
    return (
      <div className={classes.Main}>
        <Stage
          width={this.state.width}
          height={this.state.height}
          ref={node => {
            this.stage = node;
          }}
          className={classes.Stage}
          onClick={e => this.onStageClick(e)}
          onTap={e => this.onStageClick(e)}
        >
          <Layer>
            <Image
              name="background"
              image={this.state.background}
              width={this.state.width}
              height={this.state.height}
            />
            <Image
                name="frameTop"
                image={this.state.frameTop}
                /*image={(() => {
                  let img = new window.Image()
                  img.src=framesTop[0];
                  return img;
                })()}*/
                width={this.state.width}
                height={this.state.height}
            />
            <Image
                name="frameBottom"
                image={this.state.frameBottom}
                /*image={(() => {
                  let img = new window.Image()
                  img.src=framesBottom[0];
                  return img;
                })()}*/
                width={this.state.width}
                height={this.state.height}
            />
            <Image
              image={(() => {
                let img = new window.Image()
                img.src=car;
                return img;
              })()}
              x={this.state.carX}
              y={this.state.carY}
              width={this.state.carWidth}
              height={this.state.carHeight}
              name="car"
              opacity={this.state.carOpacity}
            />
            <AvatarGroup
              name="avatar"
              x={this.state.avatarPosition ? this.state.avatarPosition.x : this.state.width/2 - this.state.imgSideWidth/2}
              y={this.state.avatarPosition ? this.state.avatarPosition.y : this.state.height/2 - this.state.imgSideHeight/2}
              /*sideWidth={this.state.imgSideWidth}
              sideHeight={this.state.imgSideHeight}*/
              setInitialPosition={this.setInitialPosition}
              zoomerSide={this.state.zoomerSide}/>

            {/*this.state.checked1 && <TextGroup
             nameRef='text1'
             x={this.state.text1Position ? this.state.text1Position.x : this.state.width/2 - this.state.textWidth/2}
             y={this.state.text1Position ? this.state.text1Position.y : this.state.height/5 - this.state.textHeight}
             text={this.state.text1}
             font={this.state.font1}
             fontFamily={this.state.fontFamily}
             textStyle={this.state.textStyle}
             textColor={this.state.textColor}
             width={this.state.textWidth}
             height={this.state.textHeight}
             setInitialPosition={this.setInitialPosition}
             textTransformer="text1-transform"
             zoomerSide={this.state.zoomerSide}/>*/}
            {/*this.state.checked2 && <TextGroup
             nameRef='text2'
             x={this.state.text2Position ? this.state.text2Position.x : this.state.width/2 - this.state.textWidth/2}
             y={this.state.text2Position ? this.state.text2Position.y :this.state.height/2 - this.state.textHeight}
             text={this.state.text2}
             font={this.state.font2}
             fontFamily={this.state.fontFamily}
             textStyle={this.state.textStyle}
             textColor={this.state.textColor}
             width={this.state.textWidth}
             height={this.state.textHeight}
             setInitialPosition={this.setInitialPosition}
             textTransformer="text2-transform"
             zoomerSide={this.state.zoomerSide}/>*/}
            {/*this.state.checked3 && <TextGroup
             nameRef='text3'
             x={this.state.text3Position ? this.state.text3Position.x :this.state.width/2 - this.state.textWidth/2}
             y={this.state.text3Position ? this.state.text3Position.y :this.state.height - this.state.textHeight*4}
             text={this.state.text3}
             font={this.state.font3}
             fontFamily={this.state.fontFamily}
             textStyle={this.state.textStyle}
             textColor={this.state.textColor}
             width={this.state.textWidth}
             height={this.state.textHeight}
             setInitialPosition={this.setInitialPosition}
             textTransformer="text3-transform"
             zoomerSide={this.state.zoomerSide}/>*/}

            {this.state.gifts.length>0 && this.state.gifts.map((gift, i) => {
              return (
                <Gift
                  key={`gift-${i}`}
                  gift={gift}
                  giftsList={giftsList}
                  i={i}
                  x={gift.x}
                  y={gift.y}
                  side={gift.side}
                  image={gift.image}
                  setGiftInitialPosition={this.setGiftInitialPosition}
                  zIndex={5}
                />
              )
            })
            }
            {this.state.texts.length>0 && this.state.texts.map((text, i) => {
              return (
                <TextSolo
                  key={`text-${i}`}
                  name={`text-${i}`}
                  i={i}
                  x={text.x}
                  y={text.y}
                  width={text.width}
                  height={text.height}
                  color={text.color}
                  family={text.family}
                  italic={text.italic}
                  bold={text.bold}
                  underline={text.underline}
                  size={text.size}
                  value={text.value}
                  setTextInitialPosition={this.setTextInitialPosition}
                  carX={this.state.carX}
                  carY={this.state.carY}
                />
              )
            })
            }

            {/*this.state.gifts.length > 0 && <Gifts
             gifts={this.state.gifts}
             giftsList={giftsList}
             x={this.state.gifts.length>0 ? this.state.gifts.x : this.state.width/2 - this.state.imgSide/2}
             y={this.state.avatarPosition ? this.state.avatarPosition.y : this.state.height/2 - this.state.imgSide/2}
             side={this.state.imgSide}
             setInitialPosition={this.setInitialPosition}
             zoomerSide={this.state.zoomerSide}
             />*/}

          </Layer>
        </Stage>
        <Controls
          open={this.state.showControls}
          toggleControls={this.toggleControls}
          palette={palette}
          showPalette={this.state.showPalette}
          toggleShowPalette={this.toggleShowPalette}
          textColor={this.state.textColor}
          chooseTextColor={this.chooseTextColor}
          onFileInputChange={this.onFileInputChange}
          onInputChange={this.onInputChange}
          onInputCheck={this.onInputCheck}
          chooseNextBackground={this.chooseNextBackground}
          choosePrevBackground={this.choosePrevBackground}
          chooseNextFrameTop={this.chooseNextFrameTop}
          choosePrevFrameTop={this.choosePrevFrameTop}
          chooseNextFrameBottom={this.chooseNextFrameBottom}
          choosePrevFrameBottom={this.choosePrevFrameBottom}
          onStageSave={this.saveStage}
          sendToServer={this.sendToServer}
          randomize={this.randomize}
          addShape={this.addShape}
          addGift={this.addGift}
          showGiftPalette={this.state.showGiftPalette}
          toggleShowGiftPalette={this.toggleShowGiftPalette}
          giftsList={giftsList}
          addText={this.addText}
          currentTextSet={this.state.currentTextSet}
          findTextAndSetProps={this.findTextAndSetProps}
          changeFontSize={this.changeFontSize}
          italic={this.state.currentTextSet.italic}
          bold={this.state.currentTextSet.bold}
          underline={this.state.currentTextSet.underline}
        />
        <ControlsToggle click={this.toggleControls}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js